import { Navigation, Pagination, Autoplay }  from 'swiper/modules';
import Swiper  from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination'; 

export function initProductsSlider() {
  const container = document.querySelector('.slider__wrapper.swiper');
  if (!container) return null;

  const swiper = new Swiper(container, {
    modules: [Navigation, Pagination],
    slidesPerView: 4,
    spaceBetween: 24,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
   
    breakpoints: {
      0: { slidesPerView: 1.2, spaceBetween: 24 },
      600: { slidesPerView: 2.2, spaceBetween: 24   },
      900: { slidesPerView: 3.2, spaceBetween: 24 },
      1200: { slidesPerView: 4, spaceBetween: 24 },
    },
  });

  return swiper;
}
